export const socialConfig = {
    title: '社会参与评估表',
    explain:
        '能力完好：总分0-2分；轻度受损：总分3-7分；中度受损：总分8-13分；重度受损：总分14-20分',
    result: totleScore => {
        let result = '';
        switch (true) {
            case totleScore <= 2 && totleScore >= 0:
                result = '能力完好';
                break;
            case totleScore <= 7 && totleScore >= 3:
                result = '轻度受损';
                break;
            case totleScore <= 13 && totleScore >= 8:
                result = '中度受损';
                break;
            default:
                result = '重度受损';
                break;
        }
        return result;
    },
    qus: [
        {
            title: '生活能力：',
            options: [
                {
                    label: '除个人生活自理外（如饮食、洗漱、穿戴、二便），能料理家务（如做饭、洗衣）或当家管理事务',
                    score: 0,
                },
                { label: '除个人生活自理外，能做家务，但欠好，家庭事务安排欠条理', score: 1 },
                { label: '个人生活能自理；只有在他人帮助下才能做些家务，但质量不好', score: 2 },
                {
                    label: '个人基本生活事务（如饮食、二便）需要部分帮助或完全依赖他人帮助',
                    score: 3,
                },
            ],
        },
        {
            title: '工作能力：',
            options: [
                { label: '原来熟练的脑力工作或体力技巧性工作可照常进行', score: 0 },
                { label: '原来熟练的脑力工作或体力技巧性工作能力有所下降', score: 1 },
                { label: '原来熟练的脑力工作或体力技巧性工作明显不如以往，部分遗忘', score: 2 },
                { label: '对熟悉工作只有一些片段保留，技能全部遗忘', score: 3 },
                { label: '对以往的知识或技能全部磨灭', score: 4 },
            ],
        },
        {
            title: '时间/空间定向：',
            options: [
                {
                    label: '时间观念（年、月、日、时）清楚；可单独出远门，能很快掌握新环境的方位',
                    score: 0,
                },
                {
                    label: '时间观念有些下降，年、月、日清楚，但有时相差几天；可单独来往于近街，知道现住地的名称和方位，但不知回家路线',
                    score: 1,
                },
                {
                    label: '时间观念较差，年、月、日不清楚，可知上半年或下半年；只能单独在家附近行动，对现住地只知名称，不知道方位',
                    score: 2,
                },
                {
                    label: '时间观念很差，年、月、日不清楚，可知上午或者下午；只能在左邻右舍间串门，对现住地不知名称和方位',
                    score: 3,
                },
                { label: '无时间观念；不能单独外出', score: 4 },
            ],
        },
        {
            title: '人物定向：',
            options: [
                {
                    label: '知道周围人们的关系，知道祖孙、姑姨、侄子侄女等称谓的意义；可分辨陌生人的大致年龄和身份，可用适当称呼',
                    score: 0,
                },
                {
                    label: '只知家中亲密近亲的关系，不会分辨陌生人的大致年龄，不能称呼陌生人',
                    score: 1,
                },
                { label: '只能称呼家中人，或只能照样称呼，不知其关系，不辨辈分', score: 2 },
                { label: '只认识常同住的亲人，可称呼子女或孙子女，可辨熟人和生人', score: 3 },
                { label: '只认识保护人，不辨熟人和生人', score: 4 },
            ],
        },
        {
            title: '社会交往能力：',
            options: [
                { label: '参与社会，在社会环境有一定得适应能力，待人接物恰当', score: 0 },
                {
                    label: '能适应单纯环境，主动接触人，初见面时难让人发现智力问题，不能理解隐喻语',
                    score: 1,
                },
                {
                    label: '脱离社会，可被动接触，不会主动待人，谈话中很多不适词句，容易上当受骗',
                    score: 2,
                },
                { label: '勉强可与人交往，谈吐内容不清楚，表情不恰当', score: 3 },
                { label: '难以与人接触', score: 4 },
            ],
        },
    ],
};
